export default __webpack_public_path__ + "static/media/blog.4846031e.png";